import { ExternalLinkIcon, LoaderCircleIcon, LogInIcon, RefreshCwIcon } from 'lucide-react';

import type { AuthIssue } from '@/components/auth/auth-provider';
import { Button } from '@/components/ui/button';

export function SignInRecovery({
  issue,
  isSigningIn,
  onSignIn,
  recoveryUrl,
  signInLabel = 'Sign in with Microsoft'
}: {
  issue: AuthIssue | null;
  isSigningIn: boolean;
  onSignIn: () => Promise<void>;
  recoveryUrl: string;
  signInLabel?: string;
}) {
  if (issue?.kind === 'popupBlocked') {
    return (
      <div className="flex flex-col gap-3" role="alert" aria-live="polite">
        <p className="text-foreground text-sm">{issue.message}</p>
        <div className="flex flex-wrap gap-2">
          <Button size="sm" onClick={() => void onSignIn()} disabled={isSigningIn}>
            {isSigningIn ? (
              <LoaderCircleIcon className="animate-spin" aria-hidden />
            ) : (
              <RefreshCwIcon aria-hidden />
            )}
            Retry
          </Button>
          <Button variant="outline" size="sm" asChild>
            <a href={recoveryUrl} target="_blank" rel="noopener noreferrer">
              <ExternalLinkIcon aria-hidden />
              Open in new tab
            </a>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {issue ? (
        <p className="text-foreground text-sm" role="alert" aria-live="polite">
          {issue.message}
        </p>
      ) : null}
      <Button className="w-full" onClick={() => void onSignIn()} disabled={isSigningIn}>
        {isSigningIn ? (
          <LoaderCircleIcon className="animate-spin" aria-hidden />
        ) : (
          <LogInIcon aria-hidden />
        )}
        {isSigningIn ? 'Signing in…' : issue ? 'Try again' : signInLabel}
      </Button>
    </div>
  );
}
